import { render, staticRenderFns } from "./TrainingsModal.vue?vue&type=template&id=d56060ee&scoped=true"
import script from "./TrainingsModal.vue?vue&type=script&lang=js"
export * from "./TrainingsModal.vue?vue&type=script&lang=js"
import style0 from "./TrainingsModal.vue?vue&type=style&index=0&id=d56060ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56060ee",
  null
  
)

export default component.exports